<template>
  <div class="loading-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: "LoadLayout"
};
</script>
